
  import { mapState } from 'vuex'
  export default {
    props: {
      showEditNicknameBtn: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        editNickname: false,
        formData: {
          nickname: ''
        },
        model: null
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        operationSetting: state => state.settings.operationSetting,
        messageBadges: state => state.player.messageBadges
      }),
      infoItems() {
        return [
          {
            icon: 'mdi-account',
            text: this.tl('myProfile'),
            key: 'profile',
            to: this.$cookie.get('token') ? '/player/profile' : '/player/vip'
          },
          {
            icon: 'mdi-book',
            text:
              ~~this.operationSetting?.reg_flow === 5
                ? this.tl('walletDetail')
                : this.tl('bankDetail'),
            key: 'bank-details',
            to: '/payment-methods'
          },
          {
            icon: 'mdi-message-text-fast-outline',
            text: this.tl('message'),
            actions: this.messageBadges,
            key: 'messages',
            to: '/player/messages'
          },
          {
            icon: 'mdi-history',
            text: this.tl('history'),
            key: 'history',
            to: '/history/transaction'
          },
          {
            icon: 'mdi-lock',
            text: this.tl('resetPassword'),
            key: 'reset-password',
            to: '/reset-password'
          },
          {
            icon: 'mdi-account-group-outline',
            text: this.tl('inviteAndEarn'),
            key: 'refer-friend',
            to: '/refer-friend'
          },
          {
            icon: 'mdi-play-circle',
            text: this.tl('gameHistory'),
            key: 'game-history',
            to: '/history/game'
          }
        ]
      },
      financeList() {
        return [
          {
            icon: 'mdi-cash-plus',
            text: this.tl('deposit'),
            key: 'deposit',
            to: '/player/deposits'
          },
          {
            icon: 'mdi-cash-minus',
            text: this.tl('withdrawal'),
            key: 'withdrawal',
            to: '/player/withdrawals'
          },
          {
            icon: 'mdi-hand-extended-outline',
            text: this.tl('cashier'),
            key: 'cashier',
            to: '/cashier'
          },
          {
            icon: 'mdi-gift-outline',
            text: this.tl('myBonus'),
            key: 'myBonus',
            to: '/my-bonus'
          }
        ]
      },
      isCapital() {
        let capital = 0
        const nickname = this.player.nickname
        if (!nickname) return false
        for (const letter of nickname) {
          if (letter.charCodeAt() >= 65 && letter.charCodeAt() <= 90) {
            capital += 1
          }
        }
        return capital >= 3
      }
    },
    methods: {
      showEditNickname() {
        this.formData.nickname = this.player.nickname
        this.editNickname = !this.editNickname
      },
      updateNickname() {
        if (this.formData.nickname && this.formData.nickname !== this.player.nickname) {
          this.$store.dispatch('themes/player/doUpdatePlayerProfile', {
            ...this.formData
          })
        }
        this.editNickname = false
      }
    }
  }
